import Auth from './Auth'
import { REQUIRED } from '@/utils/rules'
export default {
  mixins: [Auth],

  data () {
    return {
      endpoint: '',
      name: '',
      entity: {},
      errors: [],
      loading: false,
      fetchSuccess: () => null,
      params: {},
    }
  },
  created: function () {
    this.load()
  },
  computed: {
    rules () {
      return [REQUIRED]
    },
  },
  methods: {
    load: function () {
      if (this.$route.params && this.$route.params.id !== 'null' && this.canRead()) {
        this.loading = true
        this.$get(`/${this.endpoint}/${this.$route.params.id}`, this.params)
          .then(response => {
            this.entity = response.data
            this.fetchSuccess()
            this.loading = false
          })
          .catch(e => {
            this.loading = false
          })
      }
    },
    save: function () {
      if (!this.entity.id && !this.canCreate()) { return }
      if (this.entity.id && !this.canUpdate()) { return }

      this.loading = true

      this.$post(`/${this.endpoint}${this.entity.id ? `/${this.entity.id}` : ''}`, this.entity)
      .then(response => {
          this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)
          !this.$route.params.id !== 'null' && this.$router.replace({ name: this.$route.name, params: { id: response.data.id } })

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
  },
}
